<template>
  <div class="p-8 bg-[#F4F7F9] min-h-screen font-sans">
    <header class="flex flex-col xl:flex-row justify-between items-start xl:items-center mb-8 gap-6">
      <div>
        <div class="flex items-center gap-3 mb-2">
          <h1 class="text-3xl font-black text-[#222222] tracking-tighter">Maintenance Globale</h1>
          <span class="px-3 py-1 bg-red-100 text-red-600 rounded-full text-[10px] font-black uppercase animate-pulse">
            {{ totalIncidents }} Incidents critiques
          </span>
        </div>
        <p class="text-gray-500 font-medium">Surveillance en temps réel de 42 terminaux sur 22 sites actifs.</p>
      </div>

      <div class="flex flex-wrap gap-3 w-full xl:w-auto">
        <div class="relative flex-1 xl:w-80">
          <input type="text" placeholder="Filtrer par agence, IP, ou erreur..." class="w-full pl-12 pr-4 py-4 bg-white border-none rounded-[1.5rem] shadow-sm text-sm focus:ring-2 focus:ring-red-500/20">
          <svg class="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
        </div>
        <select class="bg-white border-none rounded-[1.5rem] px-6 py-4 text-xs font-black uppercase tracking-widest shadow-sm">
          <option>Priorité Haute</option>
          <option>Problèmes Papier</option>
          <option>Hors-ligne</option>
        </select>
      </div>
    </header>

    <div class="grid  lg:grid-cols-12 gap-8">
      
      <div class="lg:col-span-8 space-y-8">
        
        <div class="grid md:grid-cols-2 gap-4">
          <div v-for="incident in incidentsActifs" :key="incident.id" 
               class="bg-white rounded-[2.5rem] p-6 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all group">
            <div class="flex justify-between items-start mb-6">
              <div :class="incident.priority === 'high' ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'" 
                   class="px-4 py-1.5 rounded-xl text-[9px] font-black uppercase tracking-[0.15em]">
                {{ incident.type }}
              </div>
              <span class="text-[10px] font-bold text-gray-400 bg-gray-50 px-2 py-1 rounded-lg">{{ incident.timeSince }} ago</span>
            </div>

            <div class="flex items-center gap-4 mb-6">
              <div class="w-14 h-14 bg-gray-900 rounded-[1.5rem] flex items-center justify-center shrink-0 shadow-lg">
                <svg v-if="incident.type === 'Hardware'" class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" /></svg>
                <svg v-else class="w-7 h-7 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" /></svg>
              </div>
              <div>
                <h3 class="text-lg font-black text-gray-900 leading-none mb-1">{{ incident.deviceAlias }}</h3>
                <p class="text-[10px] font-black text-dimotec-orange uppercase tracking-widest">{{ incident.clientName }}</p>
              </div>
            </div>

            <div class="p-4 bg-gray-50 rounded-2xl mb-6">
              <p class="text-xs font-bold text-gray-700">Code Erreur : <span class="text-red-600 font-mono">{{ incident.errorCode }}</span></p>
              <p class="text-[11px] text-gray-500 mt-1">{{ incident.errorLabel }}</p>
            </div>

            <div class="flex gap-2">
              <button class="flex-1 py-3 bg-gray-900 text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-black transition shadow-lg shadow-gray-200">Prendre</button>
              <button class="px-4 py-3 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
              </button>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden">
          <div class="p-6 border-b border-gray-50 flex justify-between items-center">
            <h2 class="text-sm font-black uppercase tracking-widest text-gray-400">Statut des Agences (20)</h2>
            <span class="text-[10px] font-bold text-green-500 uppercase">18/20 en ligne</span>
          </div>
          <table class="w-full text-left">
            <thead class="bg-gray-50/50 text-[10px] font-black text-gray-400 uppercase tracking-widest">
              <tr>
                <th class="px-8 py-4">Agence</th>
                <th class="px-6 py-4">Bornes</th>
                <th class="px-6 py-4">Écrans</th>
                <th class="px-6 py-4">Dernier Ping</th>
                <th class="px-6 py-4">Charge</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-50">
              <tr v-for="i in 5" :key="i" class="hover:bg-gray-50/50 transition-colors cursor-pointer">
                <td class="px-8 py-4 font-bold text-sm text-gray-900 italic">Dimotec - Paris {{ i }}</td>
                <td class="px-6 py-4"><span class="text-xs font-black">2/2</span></td>
                <td class="px-6 py-4 text-xs font-bold text-gray-500">4</td>
                <td class="px-6 py-4 text-[10px] font-mono">12:04:{{ i }}2</td>
                <td class="px-6 py-4">
                  <div class="w-16 h-1 bg-gray-100 rounded-full">
                    <div class="h-full bg-green-400 rounded-full" :style="{width: (100 - (i*5)) + '%'}"></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="lg:col-span-4 space-y-8">
        
        <div class="bg-[#1A1A1A] rounded-[3rem] p-8 text-white shadow-2xl relative">
          <div class="flex items-center justify-between mb-8">
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <h3 class="text-xs font-black uppercase tracking-widest">Global Stream</h3>
            </div>
            <button class="text-[10px] font-bold text-gray-500 border border-white/10 px-3 py-1 rounded-lg">Clear</button>
          </div>
          
          <div class="font-mono text-[10px] space-y-4 max-h-[400px] overflow-y-auto custom-scrollbar pr-2">
            <div v-for="(log, i) in consoleLogs" :key="i" class="border-l border-white/10 pl-4 py-1">
              <p class="text-dimotec-orange mb-1">[{{ log.time }}] <span class="text-white font-bold">{{ log.target }}</span></p>
              <p :class="log.type === 'error' ? 'text-red-400 font-bold' : 'text-gray-400'">{{ log.event }}</p>
            </div>
          </div>
        </div>

        <div class="bg-blue-500 rounded-[3rem] p-8 text-white shadow-xl shadow-blue-100">
          <h3 class="font-black uppercase tracking-widest text-xs mb-4">Intervention Rapide</h3>
          <p class="text-sm font-medium leading-relaxed mb-6">Un technicien est sur site et ne s'en sort pas ?</p>
          <div class="flex flex-col gap-3">
            <button class="w-full py-4 bg-white/20 rounded-2xl text-xs font-black uppercase hover:bg-white/30 transition">Ouvrir SSH Tunnel</button>
            <button class="w-full py-4 bg-black/10 rounded-2xl text-xs font-black uppercase">Appeler le Responsable</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalIncidents: 14,
      incidentsActifs: [
        { id: 1, type: 'Hardware', deviceAlias: 'Borne #042', errorCode: 'PRINTER_JAM', errorLabel: 'Échec moteur massicot (Bourrage papier)', priority: 'high', timeSince: '12min', clientName: 'DIMOTEC MONTPELLIER' },
        { id: 2, type: 'Connectivité', deviceAlias: 'TV Vitrine 02', errorCode: 'WS_TIMEOUT', errorLabel: 'Déconnexion WebSocket (Vérifier 4G)', priority: 'medium', timeSince: '1h', clientName: 'MEDIA LINK SOLUTIONS' },
        { id: 3, type: 'Hardware', deviceAlias: 'Borne #012', errorCode: 'PAPER_LOW', errorLabel: 'Moins de 10% de papier restant', priority: 'medium', timeSince: '2h', clientName: 'PHARMACIE SOLEIL' },
        { id: 4, type: 'Système', deviceAlias: 'Borne #005', errorCode: 'CPU_TEMP', errorLabel: 'Surchauffe Processeur (>85°C)', priority: 'high', timeSince: '5min', clientName: 'MAIRIE DE ST-PRIX' }
      ],
      consoleLogs: [
        { time: '13:42:01', event: 'WS_CONNECTED', target: 'Borne_42', type: 'info' },
        { time: '13:42:05', event: 'PRINT_ERR_MASSICOT', target: 'MONTPELLIER_B1', type: 'error' },
        { time: '13:42:08', event: 'HEARTBEAT_ACK', target: 'PARIS_12_TV1', type: 'info' },
        { time: '13:42:12', event: 'LOW_MEMORY_WARN', target: 'LYON_B4', type: 'error' },
        { time: '13:42:25', event: 'NEW_APK_INSTALLED', target: 'BORDEAUX_B2', type: 'info' },
      ]
    }
  }
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar { width: 2px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); }
</style>